export default {
	id: 'SIMPLE_UPGRADE_9M_89_97',
	providers: {
		stripe: '',
		braintree: '',
		paltaMap: {
			USD: 'simple_premium_9m_89_97_usd',
			EUR: 'simple_premium_9m_89_97_eur',
			GBP: 'simple_premium_9m_89_97_gbp',
			AUD: 'simple_premium_9m_129_aud',
			CAD: 'simple_premium_9m_129_cad',
			SEK: 'simple_premium_9m_1119_sek',
			BRL: 'simple_premium_9m_299_brl',
			DKK: 'simple_premium_9m_649_dkk',
			NOK: 'simple_premium_9m_1119_nok',
			MXN: 'simple_premium_9m_1559_mxn',
			TRY: 'simple_premium_9m_3099_try',
			ARS: 'simple_premium_9m_119990_ars',
			COP: 'simple_premium_9m_364390_cop',
			CLP: 'simple_premium_9m_87290_clp',
		},
		primer: 'prd_b3tyxBlKgz0U',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 9,
		intro_period_type: 'month',
		next_period_value: 9,
		next_period_type: 'month',
	},
	trial: null,
	subscription: {
		interval: 'month',
		intervalCount: 9,
		priceMap: {
			USD: 89.97,
			EUR: 89.97,
			GBP: 89.97,
			AUD: 129,
			CAD: 129,
			SEK: 1119,
			BRL: 299,
			DKK: 649,
			NOK: 1119,
			MXN: 1559,
			TRY: 3099,
			ARS: 119990,
			COP: 364390,
			CLP: 87290,
		},
	},
	options: ($t) => ({
		barChartTooltip: $t('activity_upgrade.9mo.bar_chart_tooltip'),
		barChartLeftLabel: $t('activity_upgrade.9mo.bar_chart_left_label'),
		barChartRightLabel: $t('activity_upgrade.9mo.bar_chart_right_label'),
	}),
}
